module.exports = __webpack_public_path__ + "img/20.4d072ad7.png";